export const CHAT_GPT_EDITOR_PROPS = Object.freeze(
  {
    KNOWLEDGE_TYPE: {
      id: 'knowledgeType',
      label: 'Knowledge type',
      tooltip: `
        <b>General</b>: only capable of answering generally.<br />
        <b>Custom</b>: only capable of answering with your own data.
      `
    },
    KNOWLEDGE_BASE: {
      id: 'knowledgeBase',
      label: 'Knowledge base',
      tooltip: 'Your custom knowledge base that ChatGPT will use to respond with.'
    },
    PROMPT: {
      id: 'prompt',
      label: 'System prompt',
      tooltip: `
        <b>System prompt</b> is an instruction for ChatGPT to follow. For example:
        <i class="block">
          Reply to questions regarding shoes. On any question, which doesn't regard shoes,
          reply as follows: I am sorry, I answer only questions about shoes.
        </i>
      `
    },
    USER_PROMPT: {
      id: 'userPrompt',
      label: 'User prompt',
      tooltip: `
        <b>User prompt</b> enhances <b>System prompt</b> as an additional instruction for ChatGPT to follow. For example:
        <i class="block">
          Reply in a friendly and professional manner.
        </i>
      `
    },
    SEARCH_METADATA: {
      lengthLimit: 4000,
      id: 'searchMetadata',
      label: 'Search metadata',
      tooltip: `
        <b>Search metadata</b> enhances <b>User prompt</b> with context specific information that ChatGPT can use to finetune its answer. For example:
        <i class="block">
          The customer is sending a message from https://e-shop.com/summer-sale
        </i>
      `
    },
    MAX_TOKENS: {
      id: 'maxTokens',
      label: 'Max tokens',
      tooltip: `
        <b>Max tokens</b> is a number between 0 and 128,000.
        ChatGPT stops generating a response when it reaches this limit.
      `,
      min: 0,
      max: 128000,
      step: 1
    },
    TEMPERATURE: {
      id: 'temperature',
      label: 'Creativity level',
      tooltip: `
        <b>Creativity</b> affects how freely a GPT can deviate from its knowledge (also known as Temperature).
      `
    },
    TOP_P: {
      id: 'topP',
      label: 'Top P',
      tooltip: `
        <b>Top P</b> is number between 0 and 1.
        An alternative to sampling with <b>Temperature</b>.
        We generally recommend altering one or the other, but not both.
        If you use 0.1, then only the tokens comprising the top 10% probability mass are considered.
      `,
      min: 0,
      max: 1,
      step: 0.05
    },
    FREQUENCY_PENALTY: {
      id: 'frequencyPenalty',
      label: 'Frequency penalty',
      tooltip: `
        <b>Frequency. penalty</b> is number between -2 and 2.
        Try 1.9 to reduce repeated text in an answer, and -2 to allow repetitiveness.
      `,
      min: -2,
      max: 2,
      step: 0.05
    },
    PRESENCE_PENALTY: {
      id: 'presencePenalty',
      label: 'Presence penalty',
      tooltip: `
        <b>Presence penalty</b> is number between -2 and 2.
        Try 1.9 to talk about new topics, and -2 to stay on topic.
      `,
      min: -2,
      max: 2,
      step: 0.05
    },
    TOP_N_DOCUMENTS: {
      tooltip: `
        <b>Top N Documents</b> is number between 1 to 100.
        Use this to specify the number of top-scoring documents from your data index to generate responses.
      `,
      id: 'topNDocuments',
      label: 'Top N Documents',
      min: 1,
      max: 100,
      step: 1
    },
    STRICTNESS: {
      tooltip: `
        <b>Strictness</b> is number between 1 and 5.
        Greater values raise the threshold for document relevance to filter out less relevant documents for responses.
      `,
      id: 'strictness',
      label: 'Strictness',
      min: 1,
      max: 5,
      step: 1
    }
  }
)
